export default __webpack_public_path__ + "static/media/logo-icon.84a47a38.svg";